export const GET_EMAILSTATISTICS = 'email-logs/GET_EMAILSTATISTICS';
export const GET_EMAILSTATISTICS_SUCCESS = "email-logs/GET_EMAILSTATISTICS_SUCCESS";